import { render } from "./materialImage.vue?vue&type=template&id=1434c0a9"
import script from "./materialImage.vue?vue&type=script&lang=js"
export * from "./materialImage.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contentCenter/materialImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1434c0a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1434c0a9', __exports__)) {
    console.log('reload')
    api.reload('1434c0a9', __exports__)
  }
  
  module.hot.accept("./materialImage.vue?vue&type=template&id=1434c0a9", () => {
    console.log('re-render')
    api.rerender('1434c0a9', render)
  })

}


export default __exports__